import { render, staticRenderFns } from "./SymptomsCard.vue?vue&type=template&id=4d8284c5&scoped=true"
import script from "./SymptomsCard.vue?vue&type=script&lang=js"
export * from "./SymptomsCard.vue?vue&type=script&lang=js"
import style0 from "./SymptomsCard.vue?vue&type=style&index=0&id=4d8284c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8284c5",
  null
  
)

export default component.exports